import { useQuery } from '@tanstack/react-query';

import { AssignmentGatewayMessage } from '../../../../types/AssignmentGatewayMessage';
import { SupplierCompanyMessage } from '../../../../types/SupplierCompanyMessage';
import { queries } from '../../../common/api/queryKeys/queries';
import { formatCompanyName } from '../../../common/helpers/formatCompanyName.helper';
import { useRole } from '../../../common/hooks/useRole';

export const useAssignedSuppliersOptions = () => {
    const role = useRole();
    const isSuperAdmin = role.isSuperAdmin();
    const customerIds = role.getCompanies().map((c) => c.id);

    const toOption = (supplier: SupplierCompanyMessage) => ({
        label: formatCompanyName({ company: supplier })!,
        value: supplier.id,
    });

    const allSuppliersQuery = useQuery({
        ...queries.suppliers.list(),
        enabled: isSuperAdmin,
        select: (supplierList: SupplierCompanyMessage[]) => supplierList.map(toOption),
    });

    const assignedSuppliersQuery = useQuery({
        ...queries.assignments.list({ customerIds }),
        enabled: !isSuperAdmin && customerIds.length > 0,
        select: (assignments: AssignmentGatewayMessage[]) => {
            const suppliersById = new Map<string, SupplierCompanyMessage>();
            assignments.forEach((assignment) => {
                if (assignment.supplier) {
                    suppliersById.set(assignment.supplier.id, assignment.supplier);
                }
            });

            return Array.from(suppliersById.values()).map(toOption);
        },
    });

    return isSuperAdmin ? allSuppliersQuery : assignedSuppliersQuery;
};
